import React from 'react';
import {FormattedMessage} from 'react-intl';
import {BasicDetailsLine, BasicDetailsProps} from '../../types';
import {TransferCustomLine} from '../../../../common/types';
import {Format} from '../../../../common/utils';
import styles from './BasicDetails.module.scss';

export type BasicDetailsItemProps = {
  customerName: string
  amount: React.ReactNode
  vatIncluded: string | React.ReactNode
  paymentTypeName: string
};

const BasicDetailsItem = ({
                            customerName,
                            amount,
                            vatIncluded,
                            paymentTypeName
                          }: BasicDetailsItemProps) => {
  const basicDetailsArray = [
    {
      label: <FormattedMessage id={'transfers-popup-details-customer'} defaultMessage={'Customer'}/>,
      value: customerName
    },
    {
      label: <FormattedMessage id={'transfers-popup-details-amount'} defaultMessage={'Amount'}/>,
      value: amount
    },
    {
      label: <FormattedMessage id={'transfers-popup-details-vat'} defaultMessage={'VAT'}/>,
      value: vatIncluded
    },
    {
      label: <FormattedMessage id={'transfers-popup-details-paymentType'} defaultMessage={'Payment type'}/>,
      value: paymentTypeName
    },
  ];

  return (
    <div className={styles.detailsList}>
      {basicDetailsArray.map((item, index) => {
        return (
          <div key={index} className={styles.detailsListRow}>
            <div className={styles.detailsListCol}>
              {item.label}
            </div>
            <div className={styles.detailsListCol}>
              {item.value}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const getBasicDetailsItem = (
  item: BasicDetailsLine,
  index: number,
  vatIncludedLineIds: string[]
) => {
  const customerName = [
    item.receipt.customer._id,
    '-',
    item.receipt.customer.name.first,
    item.receipt.customer.name.last,
  ].filter(Boolean).join(' ');
  const vatIncluded = vatIncludedLineIds.includes(item._id)
    ? <FormattedMessage id={'common-yes'} defaultMessage={'Yes'}/>
    : <FormattedMessage id={'common-no'} defaultMessage={'No'}/>;
  const amount = item.amount
    ? Format.displayFloatThousandsWithCommas(item.amount)
    : '0.00';
  const paymentTypeName = item?.paymentTypeName || '';

  return (
    <BasicDetailsItem
      customerName={customerName}
      amount={amount}
      vatIncluded={vatIncluded}
      paymentTypeName={paymentTypeName}
      key={index}
    />
  );
};

const getCustomLineDetailsItem = (
  item: TransferCustomLine,
  index: number,
  vatIncludedLineIds: {[key: string]: boolean}
) => {
  const vatIncluded = vatIncludedLineIds[index]
    ? <FormattedMessage id={'common-yes'} defaultMessage={'Yes'}/>
    : <FormattedMessage id={'common-no'} defaultMessage={'No'}/>;
  const amount = item.amount
    ? Format.displayFloatThousandsWithCommas(item.amount)
    : '0.00';
  const paymentTypeName = item?.paymentType || ''

  return (
    <BasicDetailsItem
      customerName={item.customer}
      amount={amount}
      vatIncluded={vatIncluded}
      paymentTypeName={paymentTypeName}
      key={index}
    />
  );
};

const BasicDetails = ({
                        vatIncludedLineIds = [],
                        vatIncludedCustomLines = {},
                        lines,
                        customLines,
                      }: BasicDetailsProps) => {
  return (
    <div className={styles.basicDetailsContainer}>
      {lines.map((item, index) => getBasicDetailsItem(item, index, vatIncludedLineIds))}
      {customLines.map((item, index) => getCustomLineDetailsItem(item, index, vatIncludedCustomLines))}
    </div>
  );
};

export default BasicDetails;
